document.addEventListener('DOMContentLoaded', function () {
  const USER_TOUCHED_KEY = 'shipping_protection_user_touched';
  let observer;

  function userAlreadyInteracted() {
    return sessionStorage.getItem(USER_TOUCHED_KEY) === 'true';
  }

  function shouldActivate() {
    return document.body.getAttribute('data-test-shipping-protection') === 'true';
  }

  function checkForElement() {
    if (userAlreadyInteracted()) return;

    const checkbox = document.querySelector('#shippingProtectionCheckBox');
    if (!checkbox) return;

    if (!shouldActivate()) {
      observer?.disconnect();
      return;
    }

    if (!checkbox.checked) {
      checkbox.click();
    }

    if (checkbox.checked) {
      observer?.disconnect();
    }
  }

  document.addEventListener(
    'click',
    function (e) {
      const el = e.target;

      if (el && el.id === 'shippingProtectionCheckBox') {
        
        const state = el.checked ? 'enabled' : 'disabled';

        gtag('event', 'shipping_protection_toggle', {
          protection_state: state,
          page_location: window.location.href
        });

       sessionStorage.setItem(USER_TOUCHED_KEY, 'true');
      }
    },
    true
  );

  // Init
  checkForElement();

  observer = new MutationObserver(checkForElement);

  observer.observe(
    document.querySelector('.site-header__drawers-container') || document.body,
    {
      childList: true,
      subtree: true
    }
  );
});
